import React from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';
import DiseasesList from '../diseases/DiseasesList';
import DiseaseGroupsList from '../diseases/DiseaseGroupsList';
import MedicinesList from '../medicines/MedicinesList';
import { HealthReferenceView } from './healthManagementNav';

interface HealthCatalogPanelProps {
  view: HealthReferenceView | string;
  onAddDisease: () => void;
  onAddGroup: () => void;
  onRefresh: () => Promise<void>;
}

export default function HealthCatalogPanel({
  view,
  onAddDisease,
  onAddGroup,
  onRefresh,
}: HealthCatalogPanelProps) {
  if (view === 'groups') {
    return (
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-medium text-slate-900">Disease groups</h3>
            <p className="text-sm text-slate-500">Organize diseases into logical categories for faster lookup.</p>
          </div>
          <button type="button" onClick={onAddGroup} className="btn btn-primary text-sm">
            <PlusIcon className="h-4 w-4" />
            Add group
          </button>
        </div>
        <DiseaseGroupsList onRefresh={() => onRefresh()} />
      </div>
    );
  }

  if (view === 'medicines') {
    return (
      <div className="space-y-4">
        <div>
          <h3 className="text-lg font-medium text-slate-900">Medicines</h3>
          <p className="text-sm text-slate-500">Reference catalog linked to diseases and treatments.</p>
        </div>
        <MedicinesList onRefresh={() => onRefresh()} />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-medium text-slate-900">Diseases</h3>
          <p className="text-sm text-slate-500">Symptoms, treatments, and linked medicines for each condition.</p>
        </div>
        <button type="button" onClick={onAddDisease} className="btn btn-primary text-sm">
          <PlusIcon className="h-4 w-4" />
          Add disease
        </button>
      </div>
      <DiseasesList onRefresh={() => onRefresh()} />
    </div>
  );
}
